/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-11 14:34:42
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-11 14:35:28
 */
import React from 'react';

import { ListPane } from '@src/types';

import { Spin, Empty } from 'antd';

interface Props {
  data: ListPane<any>;
  children: React.ReactNode;
}

const PaginationList: React.SFC<Props> = (props: Props) => {
  const { data, children } = props;

  return (
    <>
      {/*正文加载*/}
      {!data.hasLoaded && data.loading && data.list.length === 0 && (
        <div className="k-tech-loading__wrapper">
          <Spin />
        </div>
      )}

      {/*无内容*/}
      {data.hasLoaded && data.list.length === 0 && (
        <Empty className="k-tech-empty" description="暂无内容" image={<div className="img" />} />
      )}

      {/*正文内容*/}
      {data.list.length > 0 && children}
    </>
  );
};

export default React.memo(PaginationList);
